/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commission } from "../../../../api/Api";

export const getAllCommission = createAsyncThunk(
  "appCommission/getAllCommission",
  async (query) => {
    try {
      return commission.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCommission = createAsyncThunk(
  "appCommission/getCommission",
  async (id) => {
    try {
      return commission.getCommission(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const commissionActive = createAsyncThunk(
  "appCommission/commissionActive",
  async (value) => {
    return commission.active(value);
  }
);

export const addCommission = createAsyncThunk(
  "appCommission/addCommission",
  async (values) => {
    try {
      return commission.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteCommission = createAsyncThunk(
  "appCommission/deleteCommission",
  async (id) => {
    return commission.remove(id);
  }
);

export const appCommissionSlice = createSlice({
  name: "appCommission",
  initialState: {
    commissionData: [],
    commissionTotalData: {},
    commissionFetch: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCommission.fulfilled, (state, action) => {
      if (action.payload.status !== 200) {
        state.commissionData = [];
        state.commissionFetch = false;
        state.commissionTotalData = {};
        state.metaData = {};
        return;
      }
      state.metaData = action.payload?.data?.metaData;
      state.commissionData = action.payload?.data?.data;
      state.commissionTotalData = action.payload?.data?.totals;
      state.commissionFetch = true;
    });
  },
});

export default appCommissionSlice.reducer;
